export default __webpack_public_path__ + "static/technology-66c679fdd4c0be9818de8ca5258a1838.png";